const { countries } = require ('./country');
const { stripPathVersions } = require('./version');
const { attributePathToString } = require('./helper');

const resources = {
    city: 'City',
    country: 'Country',
    countryName: 'Country',
    countryPathUnitedKingdom: 'UK and Northern Ireland',
    county: 'County',
    municipality: 'Municipality',
    postalCode: 'Postal Code',
    postcode: 'Postcode',
    province: 'Province',
    state: 'State',
    suffixAustralia: 'Australia',
    suffixBrazil: 'Brazil',
    suffixCanada: 'Canada',
    suffixMexico: 'Mexico',
    suffixNetherlands: 'Netherlands',
    suffixUnitedKingdom: 'United Kingdom',
    suffixUnitedStates: 'USA',
    town: 'Town',
    townOrCity: 'Town or City',
    zipCode: 'Zip Code',
}

/**
 * The map of attribute path to localized label.
 */
const attributeLabelsByPath = new Map([
    ...countries.map((c) => [`${c}.code`,(resources.countryName)]),
    ['australia.region',resources.state],
    ['australia.region.code',resources.state],
    ['australia.locality',resources.townOrCity],
    ['australia.postalCode',resources.postcode],
    ['brazil.region',resources.state],
    ['brazil.region.code',resources.state],
    ['brazil.locality',resources.city],
    ['brazil.postalCode',resources.zipCode],
    ['canada.region',resources.province],
    ['canada.region.code',resources.province],
    ['canada.locality',resources.municipality],
    ['canada.postalCode',resources.postcode],
    ['mexico.region',resources.state],
    ['mexico.region.code',resources.state],
    ['mexico.locality',resources.city],
    ['mexico.postalCode',resources.zipCode],
    ['netherlands.region',resources.province],
    ['netherlands.region.code',resources.province],
    ['netherlands.locality',resources.city],
    ['netherlands.postalCode',resources.postcode],
    ['unitedStatesOfAmerica.region',resources.state],
    ['unitedStatesOfAmerica.region.code', resources.state],
    ['unitedStatesOfAmerica.postalCode',resources.zipCode],
    ['unitedStatesOfAmerica.locality',resources.city],
    ['unitedKingdomOfGreatBritainAndNorthernIreland',resources.countryPathUnitedKingdom],
    ['unitedKingdomOfGreatBritainAndNorthernIreland.region',resources.country],
    ['unitedKingdomOfGreatBritainAndNorthernIreland.subRegion',resources.county],
    ['unitedKingdomOfGreatBritainAndNorthernIreland.region.code',resources.country],
    ['unitedKingdomOfGreatBritainAndNorthernIreland.subRegion.code',resources.county],
    ['unitedKingdomOfGreatBritainAndNorthernIreland.postalCode',resources.postcode],
    ['unitedKingdomOfGreatBritainAndNorthernIreland.locality',resources.town],
]);

/**
 * The map of attribute path to add a label suffix.  Any path including this attribute
 * path will have suffix added.
 */
const attributeLabelSuffixesByPath = new Map([
    ['canada',resources.suffixCanada],
    ['australia',resources.suffixAustralia],
    ['brazil',resources.suffixBrazil],
    ['mexico',resources.suffixMexico],
    ['netherlands',resources.suffixNetherlands],
    ['unitedKingdomOfGreatBritainAndNorthernIreland',resources.suffixUnitedKingdom],
    ['unitedStatesOfAmerica',resources.suffixUnitedStates],
]);

/**
 * The attribute path labels to hide when showing the path.
 */
const attributePathLabelsToHide = [
    '.address',
    '.address.addressDetail',
    '.address.addressDetail.place',
    '.address.addressDetail.place.country',
];

/**
 * Return a refined label for the given attribute.  The label can be refined by hiding, suffixing or changing entirely.
 */
const refineLabel = (attribute, isPath = false) => {
    let refinedLabel = attribute.label;
    const attributePath = stripPathVersions(attributePathToString(attribute));

    let broken = false;

    if (isPath) {
        // look for path labels to hide
        broken = false;
        attributePathLabelsToHide.forEach((path) => {
            if (broken) {
                return;
            }
            if (attributePath.endsWith(path)) {
                refinedLabel = '';
                broken = true;
            }
        });
    }

    if (refinedLabel !== '') {
        // look for field and path labels to change
        broken = false;
        attributeLabelsByPath.forEach((label, path) => {
            if (broken) {
                return;
            }
            if (attributePath.endsWith(path)) {
                refinedLabel = label;
                broken = true;
            }
        });

        if (!isPath) {
            // look for field labels to augment with a suffix
            broken = false;
            attributeLabelSuffixesByPath.forEach((suffix, path) => {
                if (broken) {
                    return;
                }
                if (attributePath.includes(path)) {
                    refinedLabel += ` (${suffix})`;
                    broken = true;
                }
            });
        }
    }

    return refinedLabel;
};

module.exports = {
    refineLabel
  };
